type Signal = () => unknown;
// NOTE: This kind of recursive type alias has been supported since TS 3.7. See
// https://www.typescriptlang.org/docs/handbook/release-notes/typescript-3-7.html#more-recursive-type-aliases.
export type MaybeSignals = Signal | null | undefined | readonly MaybeSignals[];
export type SignalsAccessor<T> = (obj : T) => MaybeSignals;

export const jsonizeSignals = <T>(obj : T, signals : SignalsAccessor<T>[]) => {
    const resolvedSignals = new Set<Signal>();

    // extract the raw signal instances
    for (let accessor of signals) resolveSignals(accessor(obj), resolvedSignals);

    // if we encounter one of them while jsonizing, unwrap (call) it
    const replacer = (_key : string, value : any) => {
        if (resolvedSignals.has(value)) value = value(); // it's a listed signal, unwrap
        if (value?.toJSON) value = value.toJSON(); // if underlying type has a .toJSON, respect it
        return value; // return result for base jsonizer
    };

    return JSON.stringify(obj, replacer);
}

function resolveSignals(signals : MaybeSignals, resolved : Set<Signal>) {
    if (signals instanceof Function) {
        resolved.add(signals);
    } else if (Array.isArray(signals)) {
        for (let childSignals of signals) {
            resolveSignals(childSignals, resolved);
        }
    }
}



// WEBPACK FOOTER //
// ./lib/jsonizeSignals.ts